import React from 'react';

const Separator = () => {
  return (
    <div className='detail-separator' />
  )
}

export default Separator;
